// Function loadWelcomeBannerModal loads the WelcomeBannerModal class by dynamically importing the js on demand if needed

export function loadWelcomeBannerModal($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-welcome-banner-modal-chunk" */ '../widgets/welcomeBannerModal').then(wg => {

		const { WelcomeBannerModal } = wg;

		let $wg = $parentEl.querySelector('[data-wg="WelcomeBannerModal"]');

		if(!$wg) {
			// console.info('WelcomeBannerModal: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="WelcomeBannerModal"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new WelcomeBannerModal($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new WelcomeBannerModal($wg);
		}


	}).catch(error => error+'An error occurred while loading the WelcomeBannerModal widget');

}
